import { Flex, Icon, Link, Spacing, Tag, Text, useModal } from '@billy/design-system'
import React, { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useIntercom } from '../../../../../../../contexts/intercomContext'
import { ModalId } from '../../../../../../../enums/modalId'
import { useSegment } from '../../../../../../../hooks'
import { getImageClassName } from '../../../../../../../utils/getClassName'
import * as Styled from './styles'
import { getIntercomWidgetMarketConfigs } from './utils/getIntercomWidgetMarketConfigs'

export const IntercomWidget = (): ReactElement => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { close } = useModal(ModalId.HelpModal)
  const { track } = useSegment()
  const { show: showIntercomMessenger, showMessages: showIntercomMessagesTab } = useIntercom()

  const {
    availabilityText,
    waitingTimeText,
    Icon: CustomerSupportIcon,
  } = getIntercomWidgetMarketConfigs(t, organization?.countryId ?? 'DK')

  const handleChatClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault()
      track('xxx-help-modal-open-intercom')
      close()
      showIntercomMessenger()
    },
    [close, track, showIntercomMessenger],
  )

  const handleRecentConversationsClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault()
      track('xxx-help-modal-open-intercom-recent-conversations')
      close()
      showIntercomMessagesTab()
    },
    [close, track, showIntercomMessagesTab],
  )

  return (
    <Flex flexDirection="column" gap={Spacing.S16}>
      <Flex alignItems="center" justifyContent="space-between">
        <Text variant="bodyMD">{t('help.modal.chat.header')}</Text>
        <Link onClick={handleRecentConversationsClick}>{t('help.modal.chat.recent_conversations')}</Link>
      </Flex>
      <Styled.WidgetWrapper onClick={handleChatClick}>
        <Flex alignItems="center" gap={Spacing.S24}>
          <CustomerSupportIcon className={getImageClassName()} />
          <Flex flexDirection="column" gap={Spacing.S6}>
            {waitingTimeText && (
              <Flex alignItems="center" gap={Spacing.S6}>
                <Tag>
                  <Flex as="span" alignItems="center" gap={Spacing.S6}>
                    <Icon icon="clockArrowUp" size="lg" />
                    {waitingTimeText}
                  </Flex>
                </Tag>
              </Flex>
            )}
            <Text variant="bodyMD" weight="bold">
              {t('help.modal.chat.title')}
            </Text>
            <Text colorVariant="secondary" variant="bodySM">
              {availabilityText}
            </Text>
          </Flex>
        </Flex>
        <Icon icon="chevronRight" />
      </Styled.WidgetWrapper>
    </Flex>
  )
}
